export type AppInteractionLevel = 'view-only' | 'editable-view' | 'editable-edit';

export const DEFAULT_APP_INTERACTION_LEVEL: AppInteractionLevel = 'view-only';
